export default __webpack_public_path__ + "static/media/ic_bg_note.e7e17997.svg";